import * as MobX from "mobx";
import { Stores } from "../Stores";
import { BaseStore, KeyValuePair } from "@shoothill/core";
import { InitialState } from "../../../Globals/Models/InitialState";
import { DocumentType } from "../../../Globals/Models/DocumentType";
import { DocumentTypesEnum } from "Globals/Models/DocumentTypesEnum";

export class DocumentTypeStore extends BaseStore {
    public constructor() {
        super();
    }
    @MobX.observable private documentTypes: DocumentType[] = [];
    public async init(stores: Stores, initialState: InitialState) {
        this.documentTypes = initialState.documentTypes;
    }

    @MobX.action
    public getDocumentTypeName(documentTypeId: string | null): string {
        if (documentTypeId == null) return "";
        let documentType = this.getSortedByOrdinal.find((documentType) => documentTypeId === documentType.id);
        return documentType ? documentType.name : "Unknown";
    }

    @MobX.action
    public getDocumentTypeByType(documentTypeEnum: number) {
        // check if value passed is in Document Types Enum
        if (Object.values(DocumentTypesEnum).includes(documentTypeEnum)) {
            return this.documentTypes.find((documentType) => documentType.type == documentTypeEnum);
        }
    }

    @MobX.computed
    public get hasApprovedFormPDF() {
        const retVal = this.documentTypes.find((documentType) => documentType.type == DocumentTypesEnum.ApprovedApplicantFormPDF);
        if (retVal) {
            return true;
        } else {
            return false;
        }
    }
    @MobX.computed
    public get getSortedByOrdinal(): DocumentType[] {
        return this.documentTypes
            .slice()
            .sort((a, b) => (a.ordinal < b.ordinal ? -1 : 1))
            .filter((docType) => docType.type != DocumentTypesEnum.ApprovedApplicantFormPDF);
    }

    @MobX.computed
    public get getDocumentTypeOptions(): KeyValuePair[] {
        let placeholder = {
            key: "Please select",
            value: "",
        } as KeyValuePair;

        let options = this.getSortedByOrdinal.map((documentType) => ({ value: documentType.id, key: documentType.name })) as KeyValuePair[];

        options.unshift(placeholder);

        let index = options.findIndex((o) => o.key.toLocaleLowerCase().includes("credit report"));
        if (index > -1) {
            options.splice(index, 1);
        }

        return options;
    }
}
